<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Marketing Blasts</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="blastNew()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="blastListFiltered"
		[loading]="!blastListFiltered"
		[globalFilterFields]="app.keys(blastListFiltered)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="name">
					<div class="d-flex w-100">
						name
						<p-sortIcon field="Name"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="Name" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="created">
					<div class="d-flex w-100">
						Created Date
						<p-sortIcon field="created"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="description">
					<div class="d-flex w-100">
						Description
						<p-sortIcon field="description"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="description" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="status">
					<div class="d-flex w-100">
						columnHeader
						<p-sortIcon field="status"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="status" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td (click)="blastSelected = rec">
					{{ rec.name }}
				</td>
				<td (click)="blastSelected = rec">
					{{ moment(rec.createdDate).format("l LT") }}
				</td>
				<td class="overflow-wrap" (click)="blastSelected = rec">
					{{ rec.description }}
				</td>
				<td (click)="blastSelected = rec">
					<div>{{ rec.blastStatusString }} {{ moment(rec.sendDate).format("l LT") }}</div>
				</td>
				<td (click)="blastSelected = rec">
					<div *ngIf="rec.status === 3" class="d-flex flex-column">
						<div>Sent: {{ rec.sendCount }}</div>
						<div>Opens: {{ rec.openCount }}</div>
						<div>Opt Outs: {{ rec.optOutCount }}</div>
					</div>
				</td>
				<td class="d-flex justify-content-end">
					<p-button *ngIf="rec.status === 1" pRipple styleClass="p-button-raised p-button-warning m-2" (click)="blastRestartSend(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'play']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button *ngIf="rec.status === 2" pRipple styleClass="p-button-raised p-button-warning m-2" (click)="blastStopSend(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'pause']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button
						*ngIf="rec.status === 3"
						pRipple
						styleClass="p-button-raised p-button-secondary m-2"
						(click)="blastChangeStatus(rec, 7)"
						pTooltip="Archive this blast. It will hide it from the list, but not delete it. You can view archived Blasts by toggling it above."
					>
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'archive']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-blast-detail
	*ngIf="blastSelected && blastSelected.status === 3"
	[(blast)]="blastSelected"
	[(blastList)]="blastList"
	[templateList]="templateList"
	[groupList]="customerGroupList"
	[venueKey]="venueService.subscriptionVenue.value.key"
></app-blast-detail>
<app-blast-create-new
	*ngIf="blastSelected && blastSelected.status !== 3"
	[(blast)]="blastSelected"
	[(blastList)]="blastList"
	[templateList]="templateList"
	[groupList]="customerGroupList"
	[venueKey]="venueService.subscriptionVenue.value.key"
	(onClose)="blastSelected = undefined"
	(onSaveChange)="blastSaveFromNew($event)"
	(onDeleteChange)="blastDeleteFromNew($event)"
></app-blast-create-new>
